import React from 'react';
import { Button, Tooltip } from 'antd';
import { BulbOutlined, BulbFilled } from '@ant-design/icons';
import { useTheme } from '../../contexts/ThemeContext';

interface ThemeToggleProps {
  variant?: 'header' | 'floating';
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ variant = 'header' }) => {
  const { toggleTheme, isDark } = useTheme();

  if (variant === 'floating') {
    return (
      <Tooltip title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
        <Button
          shape="circle"
          size="large"
          onClick={toggleTheme}
          icon={isDark ? <BulbFilled /> : <BulbOutlined />}
          style={{
            backgroundColor: isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.9)',
            color: isDark ? '#faad14' : '#1890ff',
            border: isDark ? '1px solid rgba(255, 255, 255, 0.3)' : '1px solid rgba(0, 0, 0, 0.1)',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            fontSize: '20px',
            width: '48px',
            height: '48px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
      <Button
        type="text"
        size="large"
        icon={isDark ? <BulbFilled style={{ color: '#faad14', fontSize: '20px' }} /> : <BulbOutlined style={{ fontSize: '20px' }} />}
        onClick={toggleTheme}
        style={{
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '40px',
        }}
      />
    </Tooltip>
  );
};

export default ThemeToggle;
